import styled from "styled-components";

export const Container = styled.div`
    background: rgba(255, 255, 255, 0.7);
    z-index: 1001; /* antd modal has 1000 z-index value */
    width: 100vw;
    height: 100vh;
    position: fixed;
    display: ${props => (props.spinning ? "flex" : "none")};
    justify-content: center;
    align-items: center;
`;
